export const YELLOW = "#FFE580";
export const BLUE = "#96BFFF";
export const PALE_BLUE = "#B1B9FF";
export const CYAN = "#ADE4F7";
export const BRIGHT_GREEN = "#94E8A2";
export const GREEN = "#CDE894";
export const PURPLE = "#DBA8ED";
export const PINK = "#F5CDED";
export const RED = "#FFAD9D";
export const BEIGE = "#E8C694";
export const WHITE = "#FFFFFF";
export const BLACK = "#000000";

export enum ARBOLUS_COLORS {
  bColorBaseDark = "var(--brand-ink, #000A3F)",
  bColorBaseOrange = "#FF5A3A",
  bColorBasePurple = "var(--brand-interactive, #6157FC)",
  bColorAccentLink = "var(--brand-accent-link, #6157FC)",
  bColorBaseBlue = "#0062FF",
  bColorBaseWhite = "#FFFFFF",
  bColorBaseBlack = "#000000",
  bColorSecondaryGreyDark = "#80849F",
  bColorSecondaryGreyMid = "#CCCED9",
  bColorSecondaryGreyLight = "#F2F2F5",
  bColorAccentPurpleDark = "var(--brand-accent-purple-dark, #4E48D6)",
  bColorAccentPurpleMid = "var(--brand-accent-purple-mid, #7168FC)",
  bColorAccentPurpleLight = "var(--brand-accent-purple-light, #A09AFD)",
  bColorAccentPurpleSoftBg = "var(--brand-accent-purple-soft-bg, #ECECFB)",
  bColorAccentOrangeDark = "#CC4A3B",
  bColorSecondaryAmber = "#FFCC00",
  bColorAccentAmberDark = "#E5BA0F",
  bColorSecondaryGreen = "#4CD964",
  bColorAccentGreenDark = "#3DB05D",
  bColorGrayIcon = "#80859F",
  bColorBaseDarkOp = "var(--brand-ink-alpha-10, #000a3f1a)",
  bColorSecondaryGreyLightBackground = "#FAFAFD",
  bColorSecondaryOrange = "#f78104",
  bColorSecondaryOrangeDark = "#E05E00",
  angleDefaultBackgroundColor = "#F0F0F0",
  angleDefaultColor = "#BEBEBE",
  transparentGrey = "rgba(128,128,128,0.1)",
  // antD colors
  bColorWarning = "var(--antd-colorWarning, #FAAD14)",
  bColorSuccess = "var(--antd-colorSuccess, #52C41A)",
  bColorError = "#FF4D4F",
  bColorIcon = "var(--antd-colorIcon, rgba(0, 0, 0, 0.45))",
  bColorSecondary = "var(--antd-colorTextTertiary, rgba(0, 0, 0, 0.45))",
  bColorBgLayout = "var(--antd-colorBgLayout, #F5F5F5)",
  bColorTextPlaceholder = "var(--antd-colorTextPlaceholder, rgba(0, 0, 0, 0.25))",
  bCandidateIconBackground = "var(--antd-colorInfoBorderHover, #B6ABFF)",
  bColorFillSecondary = "var(--antd-colorFillSecondary, rgba(0, 0, 0, 0.06))",
  bColorFillQuaternary = "var(--antd-colorFillQuaternary, rgba(0, 0, 0, 0.02))",
  bColorText = "var(--antd-colorText, rgba(0, 0, 0, 0.88))",
  bColorBorder = "var(--antd-colorBorder, #D9D9D9)",
  bColorBgNeutral = "var(--antd-colorBorderSecondary, #F0F0F0)",
  bColorErrorBgHover = "#FFF1F0",
  bColorWarningBgHover = "var(--antd-colorWarningBg, #FFFBE6)",
  bColorSuccessBgHover = "#F6FFED",
  purple1 = "#F9F0FF",
  purple5 = "#9254DE",
  blue1 = "#E6F4FF",
  blue3 = "#91CAFF",
  blue5 = "#4096FF",
  cyan1 = "#E6FFFB",
  cyan3 = "#87E8DE",
  cyan5 = "#36CFC9",
  colorInfoBg = "var(--antd-colorInfoBg, #F3F0FF)",
  colorInfoBorder = "var(--antd-colorInfoBorder, #DBD4FF)",
  indigo4 = "#b6abff",
  indigo5 = "#8f82ff",
  bColorAngleFallback = "#722ED1",
  red3 = "#FFA39E",
  gold3 = "#FFE58F",
  gold5 = "#FFC53D",
  green1 = "#f6ffed",
  green3 = "#B7EB8F",
  green4 = "#95de64",
  green5 = "#73D13D",
  green7 = "#389E0D",
  orange6 = "var(--antd-orange-6, #fa8c16)",
  bColorErrorBg = "#fff2f0",
  bColorWarningBg = "var(--antd-colorWarningBg, #fffbe6)",
  yellow5 = "#ffec3d",
  // expert dashboard brand accents
  bColorDashboardAccentPurpleIcon = "var(--brand-dashboard-accent-icon, #5452CC)",
  bColorDashboardAccentPurpleBg = "#A09EEA",
  bColorDashboardAccentNeutralBg = "#FBF9F7",
  bColorDashboardAccentNeutralBorder = "#E4E2E1",
  bColorDashboardAccentNeutralBorderHover = "#0B1A1D",
  bColorDashboardAccentNeutralText = "#4A5254"
}

export type PALETTE =
  | typeof ARBOLUS_COLORS.bColorBaseDark
  | typeof ARBOLUS_COLORS.bColorBaseOrange
  | typeof ARBOLUS_COLORS.bColorBasePurple
  | typeof ARBOLUS_COLORS.bColorBaseBlue
  | typeof ARBOLUS_COLORS.bColorBaseWhite
  | typeof ARBOLUS_COLORS.bColorSecondaryGreyDark
  | typeof ARBOLUS_COLORS.bColorSecondaryGreyMid
  | typeof ARBOLUS_COLORS.bColorSecondaryGreyLight
  | typeof ARBOLUS_COLORS.bColorAccentPurpleDark
  | typeof ARBOLUS_COLORS.bColorAccentPurpleMid
  | typeof ARBOLUS_COLORS.bColorAccentPurpleLight
  | typeof ARBOLUS_COLORS.bColorAccentOrangeDark
  | typeof ARBOLUS_COLORS.bColorSecondaryAmber
  | typeof ARBOLUS_COLORS.bColorAccentAmberDark
  | typeof ARBOLUS_COLORS.bColorSecondaryGreen
  | typeof ARBOLUS_COLORS.bColorGrayIcon
  | typeof ARBOLUS_COLORS.bColorAccentGreenDark
  | typeof ARBOLUS_COLORS.bColorSecondaryGreyLightBackground
  | typeof ARBOLUS_COLORS.bColorSecondaryOrange
  | typeof ARBOLUS_COLORS.bColorWarning
  | typeof ARBOLUS_COLORS.bColorSuccess
  | typeof ARBOLUS_COLORS.bColorError;

export type COLOR =
  | typeof YELLOW
  | typeof BLUE
  | typeof PALE_BLUE
  | typeof CYAN
  | typeof BRIGHT_GREEN
  | typeof GREEN
  | typeof PURPLE
  | typeof PINK
  | typeof BEIGE
  | typeof RED
  | typeof WHITE
  | typeof BLACK;
